(() => {
  const grid = document.querySelector("[data-collection-grid]");
  if (!grid) return;

  const sentinel = document.querySelector("[data-collection-sentinel]");
  const loadMoreBtn = document.querySelector("[data-load-more]");

  let nextUrl = (grid.dataset.nextUrl || "").trim();
  const sectionId = (grid.dataset.sectionId || "").trim();

  let loading = false;
  let done = !nextUrl;

  function setNextUrl(url) {
    nextUrl = (url || "").trim();
    if (nextUrl) grid.dataset.nextUrl = nextUrl;
    else grid.removeAttribute("data-next-url");
    done = !nextUrl;
  }

  function showLoadMoreFallback() {
    if (!loadMoreBtn) return;
    loadMoreBtn.hidden = false;
  }

  function buildFetchUrl(url) {
    if (!sectionId) return url;
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set("section_id", sectionId);
      return u.toString();
    } catch {
      return url;
    }
  }

  function addSkeletons(count = 8) {
    removeSkeletons();
    const wrap = document.createElement("div");
    wrap.className = "sora-grid-loading";
    wrap.setAttribute("data-grid-loading", "1");

    for (let i = 0; i < count; i++) {
      const sk = document.createElement("div");
      sk.className = "sora-grid-skel";
      wrap.appendChild(sk);
    }

    grid.appendChild(wrap);
  }

  function removeSkeletons() {
    grid.querySelectorAll('[data-grid-loading="1"]').forEach(el => el.remove());
  }

  async function fetchNextPage(url) {
    const r = await fetch(buildFetchUrl(url), {
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (!r.ok) throw new Error(`Failed to fetch next page`);
    return r.text();
  }

  function parseAndExtract(htmlText) {
    const doc = new DOMParser().parseFromString(htmlText, "text/html");
    const nextGrid = doc.querySelector("[data-collection-grid]");
    if (!nextGrid) return { nodes: [], next: "" };

    const nodes = Array.from(nextGrid.querySelectorAll(".sora-wl-card"));
    const next = (nextGrid.dataset.nextUrl || "").trim();
    return { nodes, next };
  }

  async function loadNext() {
    if (loading || done) return;
    if (!nextUrl) {
      done = true;
      return;
    }

    loading = true;
    addSkeletons(8); // show 8 loading cards

    let oldBtnText = "";
    if (loadMoreBtn && !loadMoreBtn.hidden) {
      oldBtnText = loadMoreBtn.textContent;
      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = "LOADING…";
    }

    try {
      const html = await fetchNextPage(nextUrl);
      const { nodes, next } = parseAndExtract(html);

      if (!nodes.length) {
        done = true;
        return;
      }

      const frag = document.createDocumentFragment();
      nodes.forEach(n => frag.appendChild(n));
      grid.appendChild(frag);

      setNextUrl(next);
    } catch (e) {
      console.warn("[CollectionInfinite] load failed:", e);
      showLoadMoreFallback();
    } finally {
      removeSkeletons();
      if (loadMoreBtn && !loadMoreBtn.hidden) {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = oldBtnText || "LOAD MORE";
      }
      loading = false;
    }
  }

  if ("IntersectionObserver" in window && sentinel) {
    const io = new IntersectionObserver(
      entries => {
        if (entries[0]?.isIntersecting) loadNext();
      },
      { rootMargin: "800px" }
    );
    io.observe(sentinel);
  } else {
    showLoadMoreFallback();
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", loadNext);
  }
})();
